var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"mbr-section mbr-parallax-background",staticStyle:{"background-image":"url(assets/images/fazenda-732x543.jpg)","padding-top":"120px","padding-bottom":"120px"},attrs:{"id":"content5-i","data-rv-view":"17"}},[_c('div',{staticClass:"mbr-overlay",staticStyle:{"opacity":"0.7","background-color":"rgb(0, 0, 0)"}}),_c('div',{staticClass:"container"},[_c('h3',{staticClass:"mbr-section-title display-2"},[_vm._v(_vm._s(_vm.data.certificate))]),_c('div',{staticClass:"lead"},[_c('p',[_vm._v("\n          "+_vm._s(_vm.data.text)+"\n        ")])])]),_c('div',{staticClass:"container"},[_c('div',{staticClass:"lead"},[_c('div',[_c('div',[_c('MapChart',{attrs:{"countryData":{
                               'AU': 2,
                               'DZ': 1,
                               'DE': 1,
                               'BB': 1,
                               'CV': 1,
                               'CA': 1,
                               'CL': 1,
                               'KR': 1,
                               'EC': 1,
                               'ES': 1,
                               'US': 1,
                               'GD': 1,
                               'GT': 1,
                               'GY': 1,
                               'HT': 1,
                               'NL': 1,
                               'HN': 1,
                               'MU': 1,
                               'JM': 1,
                               'MR': 1,
                               'NZ': 1,
                               'PA': 1,
                               'DO': 1,
                               'LC': 1,
                               'SX': 1,
                               'SN': 1,
                               'TW': 1,
                               'TT': 1,
                               'FR': 2,
                               'PT': 1,
                               'CG': 1,
                               'AE': 1,
                               'BE': 1
                            },"highColor":"#005F32","lowColor":"#005F32","countryStrokeColor":"#909090","defaultCountryFillColor":"#dadada","LangUser":_vm.language,"showLegendContent":false}})],1)])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }